/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {consentsysGetShard} from '../api'

export const useMutationConsentsysGetShard = createReactQueryMutationHook('consentsysGetShard', consentsysGetShard)
